import { formatDateShortenToday } from 'visuris/Data/Formatters';

export default class RouteEventViewModel {
    public type: string = '';
    public title: string;
    public toolTip: string;
    public urlToDetail: string;
    public eTA: Date;
    public eTD: Date;
    public secondaryInformation: { key: string, value: string, type?: string }[];
    public highlightArrivalTime: boolean = false;
    
    public hasUrl(): boolean {
        return this.urlToDetail != null;
    }

    public hasToolTip(): boolean {
        return this.toolTip != null && this.toolTip !== "";
    }

    public hasSecondaryInformation(): boolean {
        return this.secondaryInformation != null && this.secondaryInformation.length > 0;
    }

    public formattedETA(): string {
        return formatDateShortenToday(this.eTA);
    }

    public formattedETD(): string {
        return formatDateShortenToday(this.eTD);
    }

    public hasETA(): boolean {
        return this.eTA != null;
    }

    public hasETD(): boolean {
        return this.eTD != null;
    }

}